import { QueryStatus } from "@reduxjs/toolkit/query";
import { useAppSelector } from "hooks/useAppSelector";
import { incorporationFormBuilderApis } from "store/apis/incorporationFormBuilder";

const INCORPORATION_SAVING_ENDPOINTS = new Set<string>([
  incorporationFormBuilderApis.endpoints.createFormTemplateNode.name,
  incorporationFormBuilderApis.endpoints.updateFormTemplateNode.name,
  incorporationFormBuilderApis.endpoints.deleteFormTemplateNode.name,
  incorporationFormBuilderApis.endpoints.createFormInstanceNode.name,
  incorporationFormBuilderApis.endpoints.updateFormInstanceNode.name,
  incorporationFormBuilderApis.endpoints.deleteFormInstanceNode.name,
  incorporationFormBuilderApis.endpoints.publishFormInstance.name,
  incorporationFormBuilderApis.endpoints.saveInstanceAsTemplate.name,
  incorporationFormBuilderApis.endpoints.uploadQuestionDocument.name,
]);

export const useIncorporationSaveStatus = () => {
  const mutations = useAppSelector((state) => state.api.mutations);

  const incorporationMutations = Object.values(mutations).filter(
    (mutation) =>
      mutation?.endpointName &&
      INCORPORATION_SAVING_ENDPOINTS.has(mutation.endpointName)
  );

  const isLoading = incorporationMutations.some(
    (mutation) => mutation?.status === QueryStatus.pending
  );

  const isSuccess =
    incorporationMutations.length > 0 &&
    incorporationMutations.every(
      (mutation) => mutation?.status === QueryStatus.fulfilled
    );

  return { isLoading, isSuccess };
};
